module.exports = __webpack_public_path__ + "static/media/librery.a34c232d.jpg";